import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const refundPaymentApi = createAsyncThunk(
  "refundPayment",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/refund_payment", { params });
    return response.data;
  }
);

const refundPaymentSlice = createSlice({
  name: "refundPayment",
  initialState: {
    refundPayment: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(refundPaymentApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(refundPaymentApi.fulfilled, (state, action) => {
        state.refundPayment = action.payload;
        state.loading = false;
      })
      .addCase(refundPaymentApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default refundPaymentSlice.reducer;
